export const CLASSTING_API_URL = process.env.REACT_APP_API_URL;
export const CLASSTING_EDGE_API_URL = process.env.REACT_APP_EDGE_API_URL;
export const CLASSTING_OPEN_API_URL = process.env.REACT_APP_OPEN_API_URL;
export const CLASSTING_APIS_DOMAIN = process.env.REACT_APP_APIS_DOMAIN;

export const PAGE_LOG_URL = process.env.REACT_APP_PAGE_LOG_URL;
export const EVENT_LOG_URL = process.env.REACT_APP_EVENT_LOG_URL;
export const API_LOG_URL = process.env.REACT_APP_API_LOG_URL;
